/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import uploadIcon from 'assets/images/uploadIcon.png';
import axios from 'axios';
import { Button, Input, SimpleSelect } from 'components/atoms';
import {
  useGetCategoryList,
  useGetImageUploadURL,
  useGetVideoUploadURL,
  useSaveVideo,
} from 'framework/api/methods';
import React, { FC, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export interface VideoUploadProps {
  [x: string]: any;
}

export const VideoUpload: FC<VideoUploadProps> = () => {
  const navigate = useNavigate();
  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const [videoAttachment, setVideoAttachments] = useState<any>([]);
  const [isNotAVideo, setIsNotAVideo] = useState(false);
  const [uploadProgressVideo, setUploadProgressVideo] = useState(0);
  const [uploadedVideoUrl, setUploadedVideoUrl] = useState('');
  const [videoLength, setVideoLength] = useState(0);

  const [imageAttachment, setImageAttachments] = useState<any>([]);
  const [isNotAImage, setIsNotAImage] = useState(false);
  const [uploadProgressImage, setUploadProgressImage] = useState(0);
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [categoryList, setCategoryList] = useState([]);
  const [title, setTitle] = useState('');
  const [selectedCategory, setSelectedCategory] = useState({
    label: null,
    value: null,
  });

  const onSuccessGetCategories = (data: any) => {
    setCategoryList(data?.categories?.map((item: any) => ({ label: item, value: item })));
  };

  const onErrorGetCategories = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { data } = useGetCategoryList(onSuccessGetCategories, onErrorGetCategories);

  const { mutate: getImageUploadURLMutate } = useGetImageUploadURL();

  const { mutate: getVideoUploadURLMutate } = useGetVideoUploadURL();
  const { mutate: saveVideoMutate } = useSaveVideo();

  // function to image upload
  const getImageUploadURL = (acceptedFiles: any) => {
    setUploadProgressImage(1);
    getImageUploadURLMutate(
      {
        fileName: acceptedFiles.name,
        fileType: acceptedFiles.type,
      },
      {
        onSuccess: async ({ data }: any) => {
          setUploadProgressImage(1);
          try {
            await axios.put(data.uploadUrl, acceptedFiles, {
              headers: {
                'Content-Type': acceptedFiles.type,
              },
              onUploadProgress: (progressEvent: any) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgressImage(percent);
              },
            });
            setUploadedImageUrl(data.uniqueFileName.replace(/^covers\//, ''));
            notify('Image uploaded completed!', 'success');
            setUploadProgressImage(0);
          } catch (error) {
            setUploadProgressImage(0);
            notify('Image upload failed!', 'error');
            console.error(error);
          }
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setUploadProgressImage(0);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to get video upload
  const getVideoUploadURL = (acceptedFiles: any) => {
    setUploadProgressVideo(1);
    getVideoUploadURLMutate(
      {
        fileName: acceptedFiles.name,
        fileType: acceptedFiles.type,
      },
      {
        onSuccess: async ({ data }: any) => {
          try {
            await axios.put(data.uploadUrl, acceptedFiles, {
              headers: {
                'Content-Type': acceptedFiles.type,
              },
              onUploadProgress: (progressEvent: any) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgressVideo(percent);
              },
            });
            setUploadedVideoUrl(data.uniqueFileName);
            notify('Video uploaded completed!', 'success');
            setUploadProgressVideo(0);
          } catch (error) {
            setUploadProgressVideo(0);
            notify('Video upload failed!', 'error');
            console.error(error);
          }
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setUploadProgressVideo(0);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const clearValues = () => {
    setVideoAttachments([]);
    setIsNotAVideo(false);
    setUploadProgressVideo(0);
    setUploadedVideoUrl('');
    setVideoLength(0);
    setImageAttachments([]);
    setIsNotAImage(false);
    setUploadProgressImage(0);
    setUploadedImageUrl('');
    setTitle('');
    setSelectedCategory({
      label: null,
      value: null,
    });
  };

  const saveVideo = () => {
    saveVideoMutate(
      {
        title,
        coverImageUrl: uploadedImageUrl || '',
        videoUrl: uploadedVideoUrl || '',
        category: selectedCategory.value || '',
        lengthSeconds: videoLength,
      },
      {
        onSuccess: async ({ data }: any) => {
          clearValues();
          notify('Video uploaded successfully!', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  /** handle on drop method for video */
  const onDropVideo = useCallback(
    (acceptedFiles: File[], fileRejections: any[]) => {
      if (acceptedFiles.length > 0) {
        setVideoAttachments(acceptedFiles);
        setIsNotAVideo(false);
        getVideoUploadURL(acceptedFiles[0]);

        // Set video duration
        const file = acceptedFiles[0];
        const videoElement = document.createElement('video');
        videoElement.preload = 'metadata';
        videoElement.onloadedmetadata = function () {
          window.URL.revokeObjectURL(videoElement.src);
          const duration = Math.floor(videoElement.duration);
          setVideoLength(duration);
        };
        videoElement.src = URL.createObjectURL(file);
      } else if (fileRejections.length > 0) {
        setVideoAttachments([]);
        setIsNotAVideo(true);
      }
    },
    [videoAttachment],
  );

  /** handle on drop method for image */
  const onDropImage = useCallback(
    (acceptedFiles: File[], fileRejections: any[]) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const image = new Image();

        image.src = URL.createObjectURL(file);

        image.onload = () => {
          const ratio = image.width / image.height;
          const isSixteenByNine = Math.abs(ratio - 16 / 9) < 0.01; // Small tolerance

          if (isSixteenByNine) {
            setImageAttachments([file]);
            setIsNotAImage(false);
            getImageUploadURL(file);
          } else {
            setImageAttachments([]);
            setUploadedImageUrl('');
            setIsNotAImage(true);
            notify('Only 16:9 aspect ratio images are allowed.', 'error');
          }

          URL.revokeObjectURL(image.src); // Clean up
        };

        image.onerror = () => {
          setImageAttachments([]);
          setUploadedImageUrl('');
          setIsNotAImage(true);
          notify('Invalid image file.', 'error');
        };
      } else if (fileRejections.length > 0) {
        setImageAttachments([]);
        setIsNotAImage(true);
      }
    },
    [imageAttachment],
  );

  const { getRootProps: getRootPropsVideo, getInputProps: getInputPropsVideo } = useDropzone({
    onDrop: onDropVideo,
    accept: {
      'video/mp4': ['.mp4'],
    },
    multiple: false,
    disabled: uploadProgressImage > 0,
  });

  const { getRootProps: getRootPropsImg, getInputProps: getInputPropsImg } = useDropzone({
    onDrop: onDropImage,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
    },
    multiple: false,
    disabled: uploadProgressVideo > 0,
  });

  return (
    <div className="flex flex-col justify-center items-center w-full h-full p-8 overflow-y-auto">
      <div className="bg-[white] shadow-md px-10 py-4 flex flex-col w-1/2 h-fit rounded">
        <div className="flex w-full justify-center items-center h-fit text-[#F7941E]">
          Upload your video
        </div>

        <Input
          labelValue="Title"
          inputClassName="!rounded"
          appearance="gray"
          value={title}
          onChange={(e: any) => {
            setTitle(e.target.value);
          }}
        />

        <div className="flex flex-col mt-5">
          <span className="text-[#737791] pb-1 text-sm">Category</span>

          <div className="w-2/5">
            <SimpleSelect
              isWhiteBg={false}
              isDefault={false}
              options={categoryList}
              value={selectedCategory.value === null ? null : selectedCategory}
              onChange={(e) => {
                setSelectedCategory(e);
              }}
            />
          </div>
        </div>

        <div className="flex mt-5 w-full gap-x-4">
          <div className="w-1/2">
            <span className="text-[#737791] pb-1 text-sm">Thumbnail</span>

            <div>
              {imageAttachment?.length === 0 && (
                <div
                  {...getRootPropsImg()}
                  className="flex flex-col p-[22px] border-2 border-dashed border-[#D9D9D5] rounded justify-center items-center cursor-pointer"
                >
                  <input {...getInputPropsImg()} />
                  <img alt="UploadIcon" src={uploadIcon} width={32} height={32} />

                  <span className="text-[#737791] font-semibold text-sm">Upload a file</span>

                  <span className="text-xs font-normal text-[#737791]">
                    Drag and drop file here
                  </span>
                  <span className="text-[8px] font-normal text-[#737791] text-center">
                    ( Ratio 16:9 - 1280×720, 1920×1080, 2560×1440 )
                  </span>
                </div>
              )}

              {imageAttachment.map((file: any) => (
                <li
                  key={file.path}
                  className="flex justify-between items-center bg-neutral-300 rounded w-full px-2 py-1 gap-x-4 mt-1"
                >
                  <div className="w-full flex flex-col justify-start items-start gap-x-2 ">
                    <span className="flex w-full break-all line-clamp-1 text-sm text-neutral-700 font-normal">
                      {file.name}
                    </span>
                  </div>
                  <div className="w-fit">
                    {uploadProgressImage === 0 && (
                      <i
                        className="ri-close-line"
                        onClick={() => {
                          setImageAttachments([]);
                          setUploadedImageUrl('');
                        }}
                      />
                    )}
                  </div>
                </li>
              ))}

              {uploadProgressImage > 0 && (
                <div className="w-full bg-gray-200 rounded h-2 mt-2">
                  <div
                    className="bg-[#F7941E] h-2 rounded"
                    style={{ width: `${uploadProgressImage}%` }}
                  />
                </div>
              )}

              {uploadProgressVideo > 0 && imageAttachment?.length === 0 && (
                <p className="text-sm text-red-500">Video is uploading... Please wait</p>
              )}
            </div>
            {isNotAImage && (
              <div className="text-xs text-red-600 text-center w-full">Unsupported file.</div>
            )}
          </div>

          <div className="w-1/2">
            <span className="text-[#737791] pb-1 text-sm">Upload 360 video file</span>

            <div>
              {videoAttachment?.length === 0 && (
                <div
                  {...getRootPropsVideo()}
                  className="flex flex-col p-[22px] border-2 border-dashed border-[#D9D9D5] rounded justify-center items-center cursor-pointer"
                >
                  <input {...getInputPropsVideo()} />
                  <img alt="UploadIcon" src={uploadIcon} width={32} height={32} />

                  <span className="text-[#737791] font-semibold text-sm">Upload a file</span>

                  <span className="text-xs font-normal text-[#737791]">
                    Drag and drop file here
                  </span>

                  <span className="text-[8px] font-normal text-[#737791] text-center">
                    ( Maximum video size 30GB )
                  </span>
                </div>
              )}

              {videoAttachment.map((file: any) => (
                <li
                  key={file.path}
                  className="flex justify-between items-center bg-neutral-300 rounded w-full px-2 py-1 gap-x-4 mt-1"
                >
                  <div className="w-full flex flex-col justify-start items-start gap-x-2 ">
                    <span className="flex w-full break-all line-clamp-1 text-sm text-neutral-700 font-normal">
                      {file.name}
                    </span>
                  </div>

                  <div className="w-fit">
                    {uploadProgressVideo === 0 && (
                      <i
                        className="ri-close-line"
                        onClick={() => {
                          setVideoAttachments([]);
                          setUploadedVideoUrl('');
                          setVideoLength(0);
                        }}
                      />
                    )}
                  </div>
                </li>
              ))}

              {uploadProgressVideo > 0 && (
                <div className="w-full bg-gray-200 rounded h-2 mt-2">
                  <div
                    className="bg-[#F7941E] h-2 rounded"
                    style={{ width: `${uploadProgressVideo}%` }}
                  />
                </div>
              )}

              {uploadProgressImage > 0 && videoAttachment?.length === 0 && (
                <p className="text-sm text-red-500">Image is uploading... Please wait</p>
              )}
            </div>
            {isNotAVideo && (
              <div className="text-xs text-red-600 text-center w-full">Unsupported file.</div>
            )}
          </div>
        </div>

        <div className="mt-5 flex w-full justify-start items-start">
          <Button
            isRounded
            className=""
            disabled={
              uploadProgressImage > 0 ||
              uploadProgressVideo > 0 ||
              !uploadedImageUrl ||
              !uploadedVideoUrl ||
              selectedCategory.value === null ||
              !title
            }
            onClick={() => {
              saveVideo();
            }}
          >
            Submit
          </Button>

          <Button
            isRounded
            appearance="secondary"
            className="ml-2 border-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VideoUpload;
